export function calculateScore(blocksCleared, combo) {
  if (blocksCleared === 0) return 0;
  const basePoints = blocksCleared * 10;
  const comboMultiplier = Math.max(1, combo);
  return basePoints * comboMultiplier;
}

export function getComboText(combo) {
  if (combo <= 1) return '';
  if (combo === 2) return 'DOUBLE!';
  if (combo === 3) return 'TRIPLE!';
  if (combo === 4) return 'QUAD!';
  if (combo >= 5) return `COMBO x${combo}!`;
  return '';
}
